import axios, { AxiosInstance, AxiosRequestConfig, Method } from 'axios';

const isCI = process.env.CI === 'true';

export const axiosInstance: AxiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    'X-OC-App': isCI ? 'search-playwright' : 'search-frontend',
  },
  withCredentials: true,
});

/**
 * Typesafe wrapper of an axios request that returns only the data property of the response.
 * Useful for API calls when we only need the data property of the response.
 * If the full response is needed, call {@link axiosInstance} directly.
 */
export const makeRequest = async <TData = any>(
  params: AxiosRequestConfig<TData>,
): Promise<TData> => {
  const response = await axiosInstance(params);
  return response.data;
};

export const HTTP_METHOD = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  PATCH: 'patch',
} as Record<Method, Method>;

/**
 * @deprecated use HTTP_METHOD instead
 */
export const GET = HTTP_METHOD.GET;
/**
 * @deprecated use HTTP_METHOD instead
 */
export const POST = HTTP_METHOD.POST;
/**
 * @deprecated use HTTP_METHOD instead
 */
export const PUT = HTTP_METHOD.PUT;
/**
 * @deprecated use HTTP_METHOD instead
 */
export const PATCH = HTTP_METHOD.PATCH;

type RequestMethod = 'get' | 'post' | 'put' | 'patch';

/**
 * @deprecated use {@link makeRequest} instead
 */
const request = async (method: RequestMethod, endpoint: string, body = {}, params = {}) => {
  const response = await axiosInstance[method](endpoint, body, params);
  return response.data as unknown;
};

export const upload = async (method: RequestMethod, endpoint: string, formData: FormData, params = {}) => {
  return request(method, endpoint, formData, Object.assign(
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-OC-App': 'search-frontend',
      },
    },
    params,
  ));
};

// This is exported twice for backwards compatibility
export { request };

export default request;
